import { DefaultSeoProps } from 'next-seo'

const config: DefaultSeoProps = {
  additionalLinkTags: [
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/apple-touch-icon.png',
    },

    {
      rel: 'manifest',
      href: '/site.webmanifest',
    },
    {
      rel: 'mask-icon',
      href: '/safari-pinned-tab.svg',
      color: '#9489fa',
    },
  ],
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
    {
      name: 'apple-mobile-web-app-title',
      content: 'Taylora',
    },
    {
      name: 'application-name',
      content: 'Taylora',
    },
    {
      name: 'msapplication-TileColor',
      content: '#f3f4f6',
    },
    {
      name: 'theme-color',
      content: '#f3f4f6',
    },
  ],
  defaultTitle: 'Taylora',
  facebook: {
    appId: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID,
  },
  openGraph: {
    locale: 'it_IT',
    type: 'website',
  },
  twitter: {
    cardType: 'summary_large_image',
  },
}

export const defaultFavicons = [
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: '/favicon-32x32.png',
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: '/favicon-16x16.png',
  },
  {
    as: 'default',
    rel: 'icon',
    href: '/favicon.ico',
  },
]

export const additional: DefaultSeoProps = {
  description:
    'Taylora è dove conoscenze e persone si incontrano. Una piattaforma dove chiunque può raccogliere e condividere risorse formative, insegnare e vendere i propri corsi — tutto in un unico luogo.',
  openGraph: {
    images: [
      {
        height: 1200,
        type: 'image/png',
        url: 'https://taylora.com/taylora-meta-share.png',
        width: 1200,
      },
    ],
  },
}

export default config
